import { render, staticRenderFns } from "./PromotionsCard.vue?vue&type=template&id=23475539&"
import script from "./PromotionsCard.vue?vue&type=script&lang=ts&"
export * from "./PromotionsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports